<template>
	<!-- 
		ui-edit-auto-modal.vue | automodal

		@requiere: 
		+ ui-input-handler@1.21.0 o superior
		
		@Version 1.18.0
		Recuperación de fullFormGetter y args desde Automodal y quicktable según sea el caso, 

		@Version 1.18.0
		Envía el parámetro de grouping a ui-input-handler

		@Version 1.17.2
		Actualización de Catch/try con _performSubmit

		@Version 1.17.1
		Corrección de error de displayPrinting y limpieza de modal.
		
		@Version 1.17
		Corrección de GAP exagerado de 15px por cada lado en el formulario principal.

		@Version 1.16
		Opcionalmente se puede pasar un Slot (Top) para colocar algo antes del formulario y emite el event @successStoring(data) con la respuesta de actualización/creación exitosa.

		@Version 1.15 (Bugfix)
		Repara los problemas de prelectura con form y la emisión del evento a input.

		@Version 1.14 (Bugfix)
		Permite Boolean y Number en :allowAside

		@Version 1.13
		Permite la función :beforeStore, si esta se define, puede ejecutarse antes de que se haga el submit, 
		útil para llamadas previas. Soporta async/await. Para continuar, requiere que returne true.

		@Version 1.12
		Agrega el parámetro hideButtons

		@Version 1.11 
		Permite el parámetro keepOnSuccess que en caso de true mantiene la ventana abierta al actualizar/los 
		cambios en API, se dispara el actualizado de la cuenta cuando se cierra el modal.

		@Version 1.10 (IMPORTANTE!)
		Corrige la desactualización automática desde formArchetype. Requiere un ID MD5 especial en el 
		formato de formKey.

		@Version 1.9
		Emite el evento @hidden.

		@Version 1.8
		Agergado el parémtro formId, que mejora la compatibilidad del 
		borrado general de elementos cuando éstos pueden incluir el id en otro formato.

		@Version 1.7
		Corrige un bug que impedía la preDefinición del objeto FORM.

		@Version 1.6
		Agregado el slot bottom

		@Version 1.5
		Con la función set(Form), se puede actualizar el contenido de form desde afuera.

		@Version 1.4
		Ahora emite en timpo real los datos en form como input update (para un v-model:binding correcto)

		@Version 1.3
		Agrega la propiedad no-enforce-focus al constructor de b-modal para mejorar la compatibilidad con 
			mobiscroll y ahora dispara el evento
			@defined, cuando ha terminado de cargar la información del modal/asides. 
		Remoción de autocierre del modal en backdrop click.
		Agregados los eventos:
			@display 	(Mostrado cuando se ha desplegado el modal)
			@closed		(Mostrado cuando se ha cerrado el modal)

		@Version 1.2
		Almacena todo el contenido de asides localmente y lo vuelve accesibe desde la funcion getAsides()

		@Version 1.11
		Ahora se puede etiquetar diferentes botones con las propiedades:
			cancel-label
			processing-label
			close-label
			delete-label

		@Version 1.10
		Ahora se puede establercer el estatus de isProcessing interno del módal víasetProcesing()

		@Version 1.9
		Fix que permite la actualización del valor local desde afuera

		@Version 1.8
		Ajustes para formato selectmultiple

		@Version 1.7
		Envía con el request creación/edición una copia de los parametros en $route.

		@Version 1.6
		:allowAside Permite la visualización de un slot aside! Corrección de error de slot.

		@Version 1.5
		ViewOnly y AllowDelete ahora son propiedades independientes. (AllowDelete requiere formId definido)

		@Version 1.4
		El botón de borrado no aparece si no hay un ID definido previo, además permite el parámetro viewOnly

		@Version 1.3
		Permite que se le pase un parámetro value (v-model) para que el contenedor sepa 
		los datos que el componente está trabajando/editando.

		@Version 1.2
		Esta versión permite ocultar el botón de borrado.

		@Version 1.1
		Esta nueva versión permite la sobreescritura vía btn class del botón principal, 
		además permite la confirmación de borrado con un disclaimer natural.

		@Sample:
		<ui-edit-auto-modal :refresh="refresh" :formArchetype="formArchetype" label="Editar" 
			:handler="'define/source/configuraciones/' + data.item.id" apply-button="Actualizar" size="md">
			<i class="fa fa-pencil"></i>
		</ui-edit-auto-modal>

		@Props:

		hanlder: (Requerido, String, URL)
			URL de control de datos, por ejemplo: 
				+ define/source/configuraciones (para crear una nueva entrada en la tabla configuraciones)
				+ define/source/configuraciones/:id (para realizar la prelectura de tabla y acutalizar el registro)

		form-archetype: (Requerido, Array)
			Array con cada uno de los elementos a editar, compatible con ui-input-handler, p: e:
			[
				{ key: "id", type: "hidden" },
				{ key: "promocion_nombre", label: 'Nombre de la promoción' },
				{ key: "imagenes_id", type: "image", label: 'Imágen del producto' },
			]

		formOverride: (Opcional, Objeto)
			Permite la reescritura de algun valor desde la invocación del compomente.  P. ej:
			{
				algunaClave; 'Siempre enviará este valor'
			}

		refresh: (Opcional)
			Callback a llamar al finalizar un modal

		allowDelete: (Opcional, Bolean) [Default true]
			Permite deshabilitar la capacidad de borrado del registro en BDD. 

		deleteDisclaimer: (Opcional, String) [Default "Ésta acción no se puede deshacer"]
			Mensaje textual que aparecerá en la confirmación de borrado.
		
		btn-class: (Opcional)
			Clase para sobreescribr en el boton del lanzandor

		apply-button: (Opcional)
			Etiqueta en el botón de submit

		@Author: Daniel Lepe
		@Date: 01/03/2022
	-->
	<div class="ui-edit-auto-modal" :class="btnClass" @click.stop.prevent="openModal" no-enforce-focus>

		<b v-if="isLoading" key="loading">
			<i class="fa fa-spin fa-cog"></i>
		</b>

		<template v-else>
			<slot name="default">
				<b key="normal">{{ label }}</b>
			</slot>
		</template>

		<b-modal v-if="isLoaded" v-model="isModalOn" 
			:id="currentId" 
			:modal-class="modalClass" 
			:size="size" 
			:title="label"
			:hide-footer="hideButtons" 
			@hidden="cleanModal" 
			scrollable 
			no-enforce-focus 
			no-close-on-backdrop
			no-close-on-esc>
			<b-row class="ui-edit-auto-modal-rows">
				<b-col class="col-first">
					<slot name="top"></slot>
					<b-form @submit="onSubmit($event)" :action="handler" :key="formKey">
						<template v-for="(fArch, $index) in formArchetype">
							<div class="separator" :key="$index" v-if="fArch == null">
								<hr />
							</div>
							<template v-else-if="lodash.isArray(fArch) || fArch.type != 'hidden'">
								<b-row :key="$index" v-if="lodash.isArray(fArch)" align-v="end">
									<b-col :class="(inputColumnPrefix +fArchInRow.key) | makeClass" v-for="fArchInRow in fArch" :key="fArchInRow.key">
										<ui-input-handler v-model="form[fArchInRow.key]" 
											:ref="fArchInRow.key"
											:f-arch="fArchInRow"
											:fn-to-select-from-main-query-item="getCurrentSelectedOptionFromMainQueryItemName"
											:fullFormGetter="getFullForm"
											:fArchKey="fArchInRow.key" @blur="$emit('blur', $event)"
											:multiline="fArchInRow.multiline"
											:grouping="grouping"
											:args="args"
											@focus="$emit('focus')"
											@changed="$emit('changed', fArchInRow.key, form[fArchInRow.key])" />
									</b-col>
								</b-row>
								<b-row v-else-if="fArch.type != 'hidden'" :key="fArch.key" align-v="end">
									<b-col :class="(inputColumnPrefix +fArch.key) | makeClass">
										<ui-input-handler v-model="form[fArch.key]" 
											:ref="fArch.key" 
											:f-arch="fArch"
											:fn-to-select-from-main-query-item="getCurrentSelectedOptionFromMainQueryItemName"
											:fullFormGetter="getFullForm"
											:fArchKey="fArch.key" 
											:multiline="fArch.multiline"
											:grouping="grouping"
											:args="args"
											@blur="$emit('blur', $event)" 
											@focus="$emit('focus')"
											@changed="$emit('changed', fArch.key, form[fArch.key])" />
									</b-col>
								</b-row>
							</template>
						</template>
					</b-form>
					<slot name="between"></slot>
				</b-col>
				<slot name="aside" v-if="allowAside">
					<b-col md="auto">
						slotAside! <br />
						b-col recommended.
					</b-col>
				</slot>
			</b-row>

			<slot name="bottom"></slot>
			<div id="printing" ref="printing" :class="{ uiAutoModalDisplayPrinting: displayPrinting }">
				<slot name="print"></slot>
			</div>

			<template v-slot:modal-footer="{ cancel }" v-if="!hideButtons">
				<template v-if="!isProcessing">
					<b-button-group size="sm" v-if="!!formId && allowDelete && allowDelete != 'false'">
						<b-button @click="delItem($event)" variant="danger">
							{{ deleteLabel }}
						</b-button>
					</b-button-group>

					<b-button-group size="sm" v-if="!!formId && showPrinting">
						<b-button @click="windowPrint($event)" variant="info">
							{{ printLabel }}
						</b-button>
					</b-button-group>

					<template v-if="viewOnly">
						<b-button-group size="sm">
							<b-button @click="cancel()">
								{{ closeLabel }}
							</b-button>
						</b-button-group>
					</template>


					<b-button-group v-else size="sm">
						<b-button @click="cancel()" v-if="cancelLabel">{{ cancelLabel }}</b-button>
						<slot name="extra-buttons"></slot>
						<b-button @click="onSubmit($event)" variant="primary" v-if="applyButton">
							{{ applyButton }}
						</b-button>
					</b-button-group>


				</template>

				<b-button-group size="sm" v-else>
					<b-button variant="primary" disabled> {{ processingLabel }}... </b-button>
				</b-button-group>
			</template>

		</b-modal>



	</div>
</template>

<script>
import _ from "lodash";
import axios from "axios";
import mobiscroll from "@mobiscroll/javascript";
import uiInputHandler from "./ui-input-handler.vue";
import swal from "sweetalert";

import { extractForm, Toast, translate } from '@/utils.js'



export default {
	components: { uiInputHandler },
	name: "UIEditAutoModal",
	props: {
		inputColumnPrefix: {
			type: String,
			default: "arch-col-",
		},
		args: {
            type: Object,
            default: () => { return {} }
        },
		modalClass: {
			type: String,
			default: "",
		},
		mainQueryItemName: {
			type: String,
			default: 'mainQueryItem'
		},
		showPrinting: {
			type: Boolean,
			default: false
		},
		displayPrinting: {
			type: Boolean,
			default: false
		},
		beforeStore: {
			type: Function
		},
		keepOnSuccess: {
			type: Boolean,
			default: false
		},
		formId: {
			type: [Number, String],
		},
		formIdName: {
			type: String,
			default: 'id'
		},
		cancelLabel: {
			type: [String, Boolean],
			default: translate('Cancelar')
		},
		processingLabel: {
			type: String,
			default: translate('Procesando...')
		},
		closeLabel: {
			type: String,
			default: translate('Cerrar')
		},
		deleteLabel: {
			type: String,
			default: translate('Borrar')
		},
		applyButton: {
			type: [String, Boolean, Number],
			default: translate("Guardar"),
		},
		label: {
			type: [String, Boolean, Number],
			default: translate("Editar"),
		},
		deleteDisclaimer: {
			type: String,
			default: translate("Esta acción no se puede deshacer"),
		},
		btnClass: {
			type: String,
			default: "btn btn-primary",
		},
		allowAside: {
			type: [Boolean, Number, String],
			default: false,
		},
		viewOnly: {
			type: Boolean,
			default: false,
		},
		value: {
			type: [Array, Object],
		},
		allowDelete: {
			type: [String, Number, Boolean],
			default: true,
		},
		hideButtons: {
			type: Boolean,
			default: false
		},
		refresh: {
			type: [Function],
		},
		buttonSize: {
			type: [String],
			default: () => "sm",
		},
		handler: {
			type: [String],
			required: true,
		},
		size: {
			type: [String],
			default: "md",
		},
		formKey: {
			type: String,
			default: 'formKey'
		},
		formArchetype: {
			type: [Array],
			default: () => {
				return [
					{
						key: null,
						value: null,
						default: null,
						label: "",
						readonly: null,
						type: null, // [hidden|number|price|phone|textarea|positivo|password|email]
					},
				];
			},
		},
		formOverride: {
			type: [Object],
			default: () => {
				return {};
			},
		},
	},
	computed: {},
	methods: {
		getFullForm(){
			// return {form: _.cloneDeep(this.form), args: _.cloneDeep(this.args)}
			return _.cloneDeep(this.form)
		},
		windowPrint() {
			var ticketContent = this.$refs.printing.innerHTML;
			document.getElementById('print-container').innerHTML = ticketContent;
			window.print();
			this.$emit('printEnd')
		},
		getCurrentSelectedOptionFromMainQueryItemName(valueId, valueName) {
			let foundValue;
			try {
				foundValue = this.value[this.mainQueryItemName][valueName + '_label'];
			} catch (e) {
				console.warn(e)
			}
			return foundValue;
		},
		set(value) {
			this.form = _.clone(value)
			this.$emit('input', this.form)
		},
		getAsides() {
			return this.asides;
		},
		getNaturalForm() {
			return this.form;
		},
		triggerRefresh() {
			// REFRESH
			this.$emit('refresh')
			if (typeof this.refresh == "function") this.refresh();
		},
		setProcessing(mode) {
			this.isProcessing = mode;
		},
		extractForm,
		isFormValid() {
			let validity = true;
			_.forEach(this.form, (value, keyname) => {
				let source = _.find(this.source, { name: keyname });
				if (
					!!this.$refs[keyname] &&
					this.$refs[keyname].length &&
					!this.$refs[keyname][0].isReadOnly() &&
					(value === null || value === "") &&
					typeof source == "object" &&
					source.required
				) {
					// alert(keyname)
					validity = false;
				}
			});
			return validity;
		},
		cleanModal() {
			this.isLoaded = false;
			this.$emit('closed');
			if (this.displayPrinting) {
				document.getElementById('print-container').innerHTML = '';
			}
		},
		async closeModal() {
			this.isModalOn = false;
			this.cleanModal()
		},
		async openModal() {
			this.form = extractForm(_.cloneDeep(this.formArchetype));
			this.$emit("input", this.form);
			this.source = [];
			this.isLoading = true;
			await this.define();
			this.isLoading = false;
		},
		async delItem($event) {
			let swalResponse = await swal({
				icon: 'info',
				title: translate("¿Seguro que deseas continuar?"),
				text: this.deleteDisclaimer,
				buttons: {
					cancel: translate("Cancelar"),
					danger: translate("Continuar"),
				},
			});
			if (swalResponse == "danger") {
				this.isProcessing = true;
				$event.preventDefault();

				try {
					let response = await axios.delete(this.handler);

					// ALL OKAY
					if (response.status) {
						this.$bvModal.hide(this.currentId);
						this.triggerRefresh()
					}
				} catch (message) {
					console.error(message);
					mobiscroll.snackbar({
						display: "top",
						theme: "ios",
						message,
						color: "warning",
						duration: 7000,
					});
				}
				this.isProcessing = false;
			}
		},
		async define() {
			try {
				let response = await axios.get(this.handler);

				if (response.status && !!response.originalData) {
					this.set(_.merge(this.form, response.originalData));
				}

				if (this.formOverride != {}) {
					_.forEach(this.formOverride, (item, keyname) => {
						console.log(`item, keyname`, item, keyname);
						this.form[keyname] = item;
					});
				}

				if (response.status && !!response.source) {
					this.source = response.source;
				}

				this.asides = (response.status && !!response.asides) ? response.asides : null;
				this.grouping = (response.status && !!response.grouping) ? response.grouping : null;

				this.$emit('defined', { form: this.form, source: this.source });

				this.isLoaded = true;
			} catch (message) {
				console.error(message);
				mobiscroll.snackbar({
					display: "top",
					theme: "ios",
					message,
					color: "warning",
					duration: 7000,
				});
			}
		},
		/**
		 * onSubmit
		 * 
		 * Actualización de Try/Catch con _performSubmit
		 * 
		 * @author Daniel Lepe.
		 * @version 1.2
		 * @param $event 
		 * 
		 * Ahora el onSubmit carga el isProcessing, para permitir a la función beforeStore entrar 
		 * y esperar con el botón de precarga.
		 * 
		 * @author Daniel Lepe.
		 * @version 1.1.
		 * @param $event 
		 */
		async onSubmit($event) {
			let response = false;
			this.isProcessing = true;
			try {
				if (!this.isFormValid()) {
					Toast.fire({
						type: "info",
						title: translate("Para continuar, llena los datos requeridos"),
					});
				} else if (!_.isFunction(this.beforeStore) || await this.beforeStore(this.form)) {
					$event.preventDefault();
					response = await this._performSubmit();
				}
			} catch (message) {
				console.error(message);
				mobiscroll.snackbar({
					display: "top",
					theme: "ios",
					message,
					color: "warning",
					duration: 7000,
				});
			}
			this.isProcessing = false;
			return response;
		},
		async _performSubmit() {

				let data2send = _.clone(this.form);
				data2send._route = _.cloneDeep(this.$route.params);
				const response = (this.formId) ? await axios.put(this.handler, data2send) : await axios.post(this.handler, data2send);

				// ALL OKAY
				if (response.status && !this.keepOnSuccess) {
					this.$bvModal.hide(this.currentId);
					this.triggerRefresh()
				} else if (response.status) {
					this.form[this.formIdName] = response.data[this.formIdName];
				}


				if (response.status) {
					this.$emit('successStoring', response)
				}
				return response;

		},
		updateFromModel() {
			if (JSON.stringify(this.form) != JSON.stringify(this.value)) {
				this.form = _.clone(this.value)
			}
		}
	},
	watch: {
		// FIX QUE PERMITE LA ACTUALIZACIÓN DEL VALOR LOCAL DESDE AFUERA
		value() {
			if (this.isModalOn) {
				console.log('cloning from outside')
				this.form = _.cloneDeep(this.value)
			}
		},
		isLoaded() {
			if (this.isLoaded) {
				setTimeout(() => {
					this.$bvModal.show(this.currentId);
				}, 150);
			}
		},
		isModalOn() {
			if (this.isModalOn) {
				this.$emit("input", this.form);
			} else {
				this.$emit("input", {});
			}
		}
	},
	data: () => {
		return {
			currentId: false,
			isModalOn: false,
			inputEls: {},
			lodash: _,
			isLoading: false,
			isLoaded: false,
			isProcessing: false,
			form: null,
			source: [],
			asides: null,
			grouping: null
		};
	},
	async beforeMount() {
		this.currentId = _.uniqueId("modal-form-");
	},
	updated() {
		if (JSON.stringify(this.form) !== JSON.stringify(this.value) && this.isModalOn) {
			this.$emit('input', this.form)
		}
	},
	mounted() {
		this.$root.$on('bv::modal::shown', (bvEvent, modalId) => {
			if (modalId == this.currentId) {
				console.log('Fully shown!')
				this.$emit('display')
			}
		})
		this.$root.$on('bv::modal::hidden', (bvEvent, modalId) => {
			if (modalId == this.currentId) {
				this.$emit('hidden', bvEvent, modalId)
				if (this.keepOnSuccess) {
					this.triggerRefresh()
				}
			}
		})
	}
};
</script>

<style lang="less">
.col-first {
	.separator {
		margin-left: -15px;
		margin-right: -15px;
	}
}

// .ui-edit-auto-modal-rows {
// 	@gapSize: 4px;

// 	.col-first {
// 		margin: 0 calc(@gapSize / 2) 0 calc(@gapSize / 2);
// 		position: relative;
// 		left: calc(@gapSize / 2);

// 		// border: 1px solid #c8ced3;
// 		// border-radius: 0.25rem;
// 		// background-color: #f0f3f5;
// 		// border-bottom: 1px solid #c8ced3;

// 		form {
// 			padding: @gapSize;

// 			.row {
// 				gap: calc(@gapSize * 2);
// 			}
// 		}

// 		.col {
// 			padding: 0;
// 		}
// 	}
// }

@media screen {
	#printing:not(.uiAutoModalDisplayPrinting) {
		display: none !important;
	}
}
</style>